import * as React from "react";
import ContactForm from "@components/ContactForm";
import * as styles from "./Events.module.scss";

import eventGraphic from "@images/events/event_graphic.svg";
import upcomingEventsGraphic from "@images/events/upcoming_events_graphic.svg";
import globe from "@images/index_page/work_with_us_standards.svg";
import iconDate from "@images/events/icon_date.svg";
import iconLocation from "@images/events/icon_location.svg";

const FeaturedEvent = ({
  title,
  venue,
  eventLocation,
  eventDate,
  description
}) => (
  <div className={styles.featured_event_container}>
    <div className={styles.event_inner_content}>
      <h2>{title}</h2>
      <span>
        <img src={globe} />
        <p>
          <a className={styles.event_venue_link} href={venue} target="_blank" rel="noopener noreferrer">{venue}</a>
        </p>
      </span>
      <span>
        <img src={iconLocation} />
        <p>{eventLocation}</p>
      </span>
      <span>
        <img src={iconDate} />
        <p>{eventDate}</p>
      </span>
      <p>{description}</p>
    </div>
    <img
      src={eventGraphic}
      className={`${styles.featured_img} ${styles.img_one}`}
    />
  </div>
);

export default FeaturedEvent;
